import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import GetUpliftIndexesQuery from '@/graphql/contracts/getUpliftIndexes.query.gql';
import DeleteUpliftIndexMutation from '@/graphql/contracts/deleteUpliftIndex.mutation.gql';
import {
  DeleteUpliftIndex,
  DeleteUpliftIndexVariables
} from '@/graphql/contracts/_generated_/deleteUpliftIndex.mutation';

export function useDeleteUpliftIndex(regionName?: string) {
  return useMutation<DeleteUpliftIndex, DeleteUpliftIndexVariables>(DeleteUpliftIndexMutation, {
    client: apolloClientContracts,
    refetchQueries: () => [{
      query: GetUpliftIndexesQuery,
      variables: {
        region: regionName,
        includeRates: true,
      },
    }],
  });
}
